"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormSummaryStore = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var timsort_1 = require("timsort");
var services_1 = require("../services");
function sortSummaries(summaryA, summaryB) {
    return summaryB.createdAt.localeCompare(summaryA.createdAt);
}
var FormSummaryStore = /** @class */ (function () {
    function FormSummaryStore() {
    }
    FormSummaryStore.prototype.refresh = function () {
        if (services_1.Services.Department.rest != null) {
            // Don't list stale form summaries for slow connections
            services_1.Services.Department.rest.formSummaries.init([]);
            services_1.Services.Department.rest.formSummaries.refetch();
        }
    };
    FormSummaryStore.prototype.get = function (revision) {
        var rest = services_1.Services.Department.rest;
        return rest.Form.Summary.getByRevision(revision).value;
    };
    Object.defineProperty(FormSummaryStore.prototype, "all", {
        /**
         * List of un-deleted latest form summaries deduped by form uuid
         */
        get: function () {
            if (services_1.Services.Department.current == null) {
                return [];
            }
            var rest = services_1.Services.Department.rest;
            var summaries = rest.formSummaries.value;
            if (summaries == null) {
                return [];
            }
            // Already sorted from server but good to be careful
            (0, timsort_1.sort)(summaries, sortSummaries);
            return summaries;
        },
        enumerable: false,
        configurable: true
    });
    tslib_1.__decorate([
        mobx_1.computed
    ], FormSummaryStore.prototype, "all", null);
    return FormSummaryStore;
}());
exports.FormSummaryStore = FormSummaryStore;
//# sourceMappingURL=form.summary.store.js.map